module.exports = __webpack_public_path__ + "assets/icons/ic_xrange_24px.svg";